import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="participants"
export default class extends Controller {
  static targets = [
    'relationshipSelect',
    'hasDisabilityDiv',
    'hasDisabilityCheckbox',
  ]

  declare readonly relationshipSelectTarget: HTMLSelectElement
  declare readonly hasDisabilityDivTarget: HTMLDivElement
  declare readonly hasDisabilityCheckboxTarget: HTMLInputElement

  connect () {
    this.relationshipSelectTarget.addEventListener('change', this.toggleHasDisability)
  }

  toggleHasDisability = (): void => {
    const relationship = this.relationshipSelectTarget.value
    if (relationship === 'child') {
      this.hasDisabilityDivTarget?.classList.remove('hidden')
    } else {
      this.hasDisabilityDivTarget?.classList.add('hidden')
    }
    this.hasDisabilityCheckboxTarget.disabled = relationship !== 'child'
  }
}
